// Configuration for the admin video manager (2026-10-26). Same discipline as src/api/adminUsers/config.ts: a strict
// equality flag, and 'off' (the committed default) means the Videos section does not exist at all.
//
// Its own flag on purpose: this is the feature that removes videos, and it must be able to ship, or be rolled back,
// independently of every other admin section.
//
// MOCK NEVER IN A PRODUCTION BUILD (Igor's review of #82). NODE_ENV comes from the build command (react-scripts:
// production for `npm run build`, development for `npm start`, test under jest), and no environment variable can
// change it, so a deployed build maps 'mock' to 'off' whatever the GitHub variable says. No environment name is read.
const MOCK_ALLOWED = process.env.NODE_ENV !== 'production';

export const ADMIN_VIDEOS_MODE: 'off' | 'mock' | 'live' =
  process.env.REACT_APP_ADMIN_VIDEOS_MODE === 'live'
    ? 'live'
    : process.env.REACT_APP_ADMIN_VIDEOS_MODE === 'mock' && MOCK_ALLOWED
      ? 'mock'
      : 'off';

export const ADMIN_VIDEOS_ENABLED = ADMIN_VIDEOS_MODE !== 'off';

export const ADMIN_VIDEOS_PATH = process.env.REACT_APP_ADMIN_VIDEOS_PATH || '';

export const ADMIN_VIDEOS_TIMEOUT_MS = 30_000;
// Longer than the gateway's own 50 s timeout for the bulk call, so the gateway's per-video report always arrives
// before this client gives up.
export const ADMIN_VIDEOS_BULK_TIMEOUT_MS = 58_000;

// The gateway's Removal filter value for "not removed" (its removalState filter: none, removed, archived, ...). Sent
// with every Status choice (Joey, 27 Oct): VPM marks a removed video Failed, and "Failed" must never list one.
export const REMOVAL_FILTER_NOT_REMOVED = 'none';

// The Status filter the Videos list starts on (Joey, 27 Oct): Live (VPM's Ready), so failed and removed videos are not
// in the first view; Any, Processing and Failed are one choice away. The server lists one status at a time, so
// "everything but Failed" is not something it can be asked for.
export const DEFAULT_STATUS_FILTER = 'Ready';

// A VPM video id. Used only to tell an admin which pasted entries are not video ids; the gateway checks every id itself.
export const VIDEO_ID_PATTERN = /^[0-9a-f]{32}$/;
